// extracted by mini-css-extract-plugin
export default {"comment-indicator":"DiffLineTableCellParts-module__comment-indicator--EOzeT","in-progress-comment-indicator":"DiffLineTableCellParts-module__in-progress-comment-indicator--DmbGA"};